import {Image} from "../../types/admin";
import {ADMIN_LANG} from "../../settings";
import {Button, Form, InputGroup} from "react-bootstrap";
import React from "react";

type Props = {
    defaultImage: Image | null
    setImage: (image: File | null) => void
    label?: string
    help_text?: string
    accept?: string
    imageWidth?: string
}

const ImageField = ({
                        defaultImage,
                        setImage,
                        label = ADMIN_LANG.image,
                        help_text = ADMIN_LANG.image_help,
                        accept = '',  // image/jpeg,image/png,image/jpg
                        imageWidth = 'auto'
                    }: Props) => {

    const handleImageAdd = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (e.target.files && e.target.files.length > 0) {
            setImage(e.target.files[0]);
        }else{
            setImage(null);
        }
    }

    let elem;

    if (defaultImage) {
        elem = (
            <Form.Group className='pb-3'>
                <Form.Label>{label}</Form.Label>
                <div className='d-md-flex align-items-center'>
                    <img width={imageWidth} src={defaultImage.url} alt={defaultImage.name}
                         className='img-fluid rounded'/>
                    <Button variant='secondary' onClick={() => setImage(null)}
                            className='ms-md-3 mt-3 mt-md-0'>{ADMIN_LANG.change_remove}</Button>
                </div>
            </Form.Group>
        );
    } else {
        elem = (
            <Form.Group className='pb-3' controlId={label}>
                <Form.Label>{label}</Form.Label>
                <InputGroup>
                    <Form.Control type='file' onChange={handleImageAdd} accept={accept}/>
                </InputGroup>
                <Form.Text className='help-text'
                           dangerouslySetInnerHTML={{__html: help_text}}></Form.Text>
            </Form.Group>
        );
    }

    return (
        <>
            {elem}
        </>
    )
}


export default ImageField;